import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { urlConst } from '../../consts';
import MainPage from '../pages/MainPage';
import LoginPage from '../pages/LoginPage';
import RegPage from '../pages/RegPage';
import ProgramPage from '../pages/ProgramPage';
import ResetPassPage from '../pages/ResetPassPage';
import MessagePage from '../pages/MessagePage';
import { PrivateContent } from './PrivateContent';
import ProfilePage from '../pages/ProfilePage';
import RequestsPage from '../pages/RequestsPage';
import NewRequestPage from '../pages/NewRequestPage';

export function RoutesPage() {
    return (
        <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path={`${urlConst.LOGIN}`} element={<LoginPage />} />
            <Route path={`${urlConst.REGISTRATION}`} element={<RegPage />} />
            <Route path={`${urlConst.RESET_PASS}`} element={<ResetPassPage />} />
            <Route path={`${urlConst.MESSAGE}`} element={<MessagePage />} />

            <Route path={`${urlConst.PROGRAM}/*`} element={<ProgramPage />} />
            <Route path={`event/:eventName/${urlConst.PROGRAM}/*`} element={<ProgramPage />} />

            <Route
                path={`${urlConst.PROFILE}`}
                element={
                    <PrivateContent>
                        <ProfilePage />
                    </PrivateContent>
                }
            />
            <Route
                path={`${urlConst.NEW_REQUEST}/*`}
                element={
                    <PrivateContent>
                        <NewRequestPage />
                    </PrivateContent>
                }
            />
            <Route
                path={`${urlConst.REQUESTS}/*`}
                element={
                    <PrivateContent>
                        <RequestsPage />
                    </PrivateContent>
                }
            />
            <Route
                path={`event/:eventName/${urlConst.REQUESTS}/*`}
                element={
                    <PrivateContent>
                        <RequestsPage />
                    </PrivateContent>
                }
            />

            <Route path="*" element={<h1>404 Страница не найдена</h1>} />
        </Routes>
    );
}
